export const courses = [
  {
    id: 'career-mapping-101',
    title: 'Career Mapping 101',
    description: 'Learn to visualize and plan your non-linear STEAM career path. Discover how to connect your skills, interests, and opportunities in ways that traditional career advice never taught you. Includes downloadable resources.',
    whoIsItFor: 'Early-career professionals and students in STEAM fields looking to take control of their career trajectory.',
    format: 'Self-paced',
    duration: '4 weeks',
    price: '$197',
    status: 'available',
    featured: true,
    image: 'https://images.pexels.com/photos/3184287/pexels-photo-3184287.jpeg?auto=compress&cs=tinysrgb&w=800'
  },
  {
    id: 'wellness-for-stem',
    title: 'Wellness for STEM Professionals',
    description: 'Integrate mindfulness and self-care practices into your demanding STEM career. Build sustainable habits that prevent burnout and enhance creativity. Includes downloadable resources.',
    whoIsItFor: 'STEM professionals experiencing burnout or seeking better work-life integration.',
    format: 'Live cohort',
    duration: '6 weeks',
    price: '$347',
    status: 'available',
    featured: true,
    image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&w=800'
  },
  {
    id: 'leadership-lab',
    title: 'STEM Leadership Lab',
    description: 'Develop the leadership skills you need to advance in technical fields while staying true to your values. Learn to lead with empathy and strategic thinking. Includes downloadable resources.',
    whoIsItFor: 'Mid-career STEM professionals ready to move into leadership roles.',
    format: 'Hybrid',
    duration: '8 weeks',
    price: '$497',
    status: 'coming-soon',
    featured: false,
    image: 'https://images.pexels.com/photos/3184360/pexels-photo-3184360.jpeg?auto=compress&cs=tinysrgb&w=800'
  },
  {
    id: 'family-career-balance',
    title: 'Balancing Family & STEM Career',
    description: 'Practical strategies for navigating parenthood while maintaining a thriving STEM career. Real talk, real solutions, real support. Includes downloadable resources.',
    whoIsItFor: 'Working parents or those planning to start families while in demanding STEM roles.',
    format: 'Self-paced',
    duration: '4 weeks',
    price: '$247',
    status: 'coming-soon',
    featured: false,
    image: 'https://images.pexels.com/photos/4260325/pexels-photo-4260325.jpeg?auto=compress&cs=tinysrgb&w=800'
  }
];

export const offerings = [
  {
    id: 'career-workbook',
    title: 'Career Trajectory Workbook',
    description: 'A comprehensive 50-page workbook to map your unique career path with exercises, templates, and reflection prompts.',
    downloadableNote: 'Downloadable PDF format',
    price: '$29',
    type: 'workbook',
    image: 'https://images.pexels.com/photos/733857/pexels-photo-733857.jpeg?auto=compress&cs=tinysrgb&w=400'
  },
  {
    id: 'resume-templates',
    title: 'STEM Resume Templates',
    description: 'Five ATS-friendly resume templates designed specifically for STEM professionals at different career stages.',
    downloadableNote: 'Downloadable in Word & PDF formats',
    price: '$19',
    type: 'template',
    image: 'https://images.pexels.com/photos/590016/pexels-photo-590016.jpeg?auto=compress&cs=tinysrgb&w=400'
  },
  {
    id: 'mini-course-networking',
    title: 'Networking for Introverts',
    description: 'A 90-minute video course on building meaningful professional connections without the awkwardness.',
    downloadableNote: 'Downloadable video + worksheet',
    price: '$47',
    type: 'course',
    image: 'https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=400'
  }
];
